<script setup lang="ts">
definePageMeta({
  layout: 'fund',
})

useSetSEO()

const { locale, t } = useI18n()
const { gtEvent } = useGoogleTag()

const handleOnGoGaudiCreator = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: t('fund.gaudiFund.fundMessage.lmnovaGaudi'),
    eventLabel: t('fund.gaudiFund.fundMessage.lmnovaGaudi'),
    eventSlot: '',
    eventI18nAddr: t('fund.gaudiFund.fundMessage.lmnovaGaudi'),
    eventComponent: 'Button',
  })
  useNavigations({ url: '/creator/@gaudilm2023' })
}
</script>

<template>
  <div class="gaudi-wrap">
    <div class="gaudi-header">
      <img
        src="@/assets/images/fund/gaudi/gaudi-header-text.svg?url"
        alt="GAUDI FUND The Moon Ent X Gaudi Knowledge Association"
      />
    </div>
    <div class="gaudi-content">
      <div class="gaudi-top-image">
        <div v-if="locale === 'ko'" class="locale-group">
          <img
            src="@/assets/images/fund/gaudi/gaudi-fund-image-ko.jpg"
            alt="GAUDI FUND"
          />
        </div>
        <div v-else class="locale-group">
          <img
            src="@/assets/images/fund/gaudi/gaudi-fund-image-en.jpg"
            alt="GAUDI FUND"
          />
        </div>
      </div>
      <ul class="gaudi-fund-message">
        <li class="message-1">
          <p
            v-dompurify-html="$t(`fund.gaudiFund.fundMessage.theMoonLabs`)"
            class="title"
          />
          <div
            v-dompurify-html="
              $t(`fund.gaudiFund.fundMessage.theMoonLabsMessage`)
            "
            class="message"
          />
        </li>
        <li class="message-2">
          <p
            v-dompurify-html="$t(`fund.gaudiFund.fundMessage.lmnova`)"
            class="title"
          />
          <div
            v-dompurify-html="$t(`fund.gaudiFund.fundMessage.lmnovaMessage`)"
            class="message"
          />
          <div class="message">
            <NovaButtonSimpleText
              :label="$t('fund.gaudiFund.fundMessage.lmnovaGaudi')"
              class="directLink"
              @click="handleOnGoGaudiCreator"
            >
              <template #extra>
                <NovaIcon
                  :icon="{ type: 'outline', name: 'carrot-right' }"
                  class="icon"
                />
              </template>
            </NovaButtonSimpleText>
          </div>
        </li>
        <li class="message-3">
          <p
            v-dompurify-html="$t(`fund.gaudiFund.fundMessage.plan`)"
            class="title"
          />
          <div class="message">
            <dl>
              <dt
                v-dompurify-html="
                  $t(`fund.gaudiFund.fundMessage.planMessage.planTitle1.title`)
                "
              />
              <dd>
                <ul>
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle1.message1`
                      )
                    "
                  />
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle1.message2`
                      )
                    "
                  />
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle1.message3`
                      )
                    "
                  />
                </ul>
              </dd>
            </dl>
            <dl>
              <dt
                v-dompurify-html="
                  $t(`fund.gaudiFund.fundMessage.planMessage.planTitle2.title`)
                "
              />
              <dd>
                <ul>
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle2.message1`
                      )
                    "
                  />
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle2.message2`
                      )
                    "
                  />
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle2.message3`
                      )
                    "
                  />
                </ul>
              </dd>
            </dl>
            <dl>
              <dt
                v-dompurify-html="
                  $t(`fund.gaudiFund.fundMessage.planMessage.planTitle3.title`)
                "
              />
              <dd>
                <ul>
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle3.message1`
                      )
                    "
                  />
                </ul>
              </dd>
            </dl>
            <dl>
              <dt
                v-dompurify-html="
                  $t(`fund.gaudiFund.fundMessage.planMessage.planTitle4.title`)
                "
              />
              <dd>
                <ul>
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle4.message1`
                      )
                    "
                  />
                  <li
                    v-dompurify-html="
                      $t(
                        `fund.gaudiFund.fundMessage.planMessage.planTitle4.message2`
                      )
                    "
                  />
                </ul>
              </dd>
            </dl>
          </div>
        </li>
      </ul>
    </div>
    <div class="gaudi-fund-roadmap">
      <div v-if="locale === 'ko'" class="locale-group">
        <img
          class="desktop"
          src="@/assets/images/fund/gaudi/gaudi-roadmap-pc-ko.jpg"
          :alt="$t('auction.topBanner.alt')"
        />
        <img
          class="mobile"
          src="@/assets/images/fund/gaudi/gaudi-roadmap-mob-ko.jpg"
          :alt="$t('auction.topBanner.alt')"
        />
      </div>
      <div v-else class="locale-group">
        <img
          class="desktop"
          src="@/assets/images/fund/gaudi/gaudi-roadmap-pc-en.jpg"
          :alt="$t('auction.topBanner.alt')"
        />
        <img
          class="mobile"
          src="@/assets/images/fund/gaudi/gaudi-roadmap-mob-en.jpg"
          :alt="$t('auction.topBanner.alt')"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gaudi-wrap {
  padding-bottom: 20px;

  .gaudi-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 47px 30px;
    background: url('@/assets/images/fund/gaudi/gaudi-header-bg.png?url')
      no-repeat center center;
    @include tablet {
      padding: 40px 30px;
    }
    @include mobile {
      padding: 30px 30px;
    }
    img {
      width: 100%;
      max-width: 415px;
      @include tablet {
        max-width: 340px;
      }
      @include mobile {
        max-width: 250px;
      }
    }
  }

  .gaudi-content {
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
    padding: 55px 0 0 0;

    @include tablet {
      padding: 30px;
    }

    @include mobile {
      padding: 10px;
    }

    .gaudi-fund-message {
      display: block;
      width: 100%;
      max-width: 760px;
      margin: 0 auto;
      padding-top: 20px;
      padding-bottom: 45px;

      @include mobile {
        padding-top: 10px;

        .pc-br {
          display: none;
        }
      }

      .pc-br {
        display: block;
      }

      li {
        padding-top: 30px;

        @include mobile {
          padding-top: 15px;
        }

        > .title {
          @include text-style($text-custom-22-bold);
          color: #8e007d;
          padding-top: 20px;
          padding-left: 54px;

          @include mobile {
            padding-top: 5px;
            padding-left: 35px;
            & {
              @include text-style($text-custom-18-bold);
            }
          }
        }

        > .message {
          padding: 12px 0 0 54px;
          font-size: 14px;

          @include text-style($text-body-14-medium);
          @include mobile {
            padding-left: 35px;
          }

          :deep(.pc-br) {
            display: block;
            @include mobile {
              display: none;
            }
          }

          .directLink {
            gap: 6px;
            height: 26px;
            line-height: 1;
            padding: 0 3px 0 12px;
            //background: url('assets/images/fund/gaudi/directLink-bg.png')
            //  no-repeat left center;
            //background-size: 100% 25px;
            background: rgb(124, 188, 239);
            background: linear-gradient(
              90deg,
              rgba(124, 188, 239, 1) 0%,
              rgba(239, 75, 137, 1) 100%
            );
            border-bottom-right-radius: 13px;
            border-bottom-left-radius: 13px;
            border-top-right-radius: 13px;

            :deep(.label) {
              @include text-style($text-body-12-medium);
              color: #fff;
            }

            .icon {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: 20px;
              height: 20px;
              background-color: $color-bg-3;
              border-radius: 50%;
              font-size: 28px !important;
              color: rgba(239, 75, 137, 1);

              &:before {
                margin-left: 2px;
              }
            }
          }
          dl {
            padding-top: 30px;

            @include mobile {
              padding-top: 10px;
            }

            &:first-child {
              padding-top: 10px;
            }

            dt {
              padding-bottom: 5px;
              @include text-style($text-custom-18-bold);
              color: #8e007d;

              @include mobile {
                & {
                  @include text-style($text-body-14-bold);
                }
              }
            }

            dd {
              li {
                padding-left: 18px;
                padding-top: 5px;
                text-indent: -18px;

                &:before {
                  display: inline-block;
                  vertical-align: middle;
                  margin-right: 14px;
                  width: 4px;
                  height: 4px;
                  border-radius: 2px;
                  content: '';
                  background: #000;
                }
              }
            }
          }
        }

        &.message-1 > .title {
          background: url('@/assets/images/fund/gaudi/gaudi-icon01.svg?url')
            no-repeat left bottom;
          background-size: 33px auto;
          @include mobile {
            background-size: 22px auto;
          }
        }

        &.message-2 > .title {
          background: url('@/assets/images/fund/gaudi/gaudi-icon02.svg?url')
            no-repeat left bottom;
          background-size: 33px auto;
          @include mobile {
            background-size: 22px auto;
          }
        }

        &.message-3 > .title {
          background: url('@/assets/images/fund/gaudi/gaudi-icon03.svg?url')
            no-repeat left bottom;
          background-size: 33px auto;
          @include mobile {
            background-size: 22px auto;
          }
        }
      }
    }
  }

  .gaudi-fund-roadmap {
    @include mobile {
      padding: 0 10px;
    }

    img {
      margin: 0 auto;
    }

    .desktop {
      display: block;
      @include mobile {
        display: none;
      }
    }

    .mobile {
      display: none;
      @include mobile {
        display: block;
      }
    }
  }
}
</style>
